'use client';

// @spec authentication-environment-switch

import { useUrlErrorParam } from '@client/hooks/use-url-error-param';
import { signIn } from 'next-auth/react';

import { UrlErrorBanner } from './url-error-banner';

/**
 * Displays a user-friendly message when cross-environment sign-in fails.
 * Handles three distinct error codes:
 *   - `AuthFailed` — JWT expired or generic auth failure (retrying may help)
 *   - `AuthNoAccount` — No linked Google account (retrying won't help)
 *   - `AuthConfigError` — Server misconfiguration (retrying won't help)
 *
 * Mounted in the root layout (outside AuthenticatedLayout) so it renders
 * even when the session is missing.
 */
export function AuthFailedError() {
  const showFailed = useUrlErrorParam('AuthFailed');
  const showNoAccount = useUrlErrorParam('AuthNoAccount');
  const showConfigError = useUrlErrorParam('AuthConfigError');

  if (showNoAccount) {
    return (
      <UrlErrorBanner message="Sign-in failed: no linked Google account found. Please sign in on the main site first." />
    );
  }

  if (showConfigError) {
    return (
      <UrlErrorBanner message="Sign-in failed due to a server configuration issue. Please try again later." />
    );
  }

  if (showFailed) {
    return (
      <UrlErrorBanner
        message="Sign-in failed. Please try again."
        actionLabel="Try Again"
        onAction={() => void signIn('google')}
      />
    );
  }

  return null;
}
